import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const TRAINING_BANNER = `${process.env.PUBLIC_URL}/assets/training-banner.png`;

/**
 * Shared brand hero for Training dropdown destination pages.
 * Uses a consistent photo banner background across all training sections.
 */
const TrainingHero = ({
  badge,
  title,
  subtitle,
  icon: Icon,
  primaryCta,
  secondaryCta,
}) => {
  return (
    <section className="relative text-white py-28 md:py-36 lg:py-40 px-4 overflow-hidden min-h-[420px] md:min-h-[520px] lg:min-h-[580px] flex items-center">
      {/* Background banner image */}
      <div className="absolute inset-0" aria-hidden="true">
        <img
          src={TRAINING_BANNER}
          alt=""
          className="w-full h-full object-cover object-center"
        />
        {/* Dark overlay for text contrast + brand tint */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#1a1a2e]/85 via-[#3d1f5c]/75 to-[var(--bg-primary)]/80" />
        <div className="absolute inset-0 bg-black/25" />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 28 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.65 }}
        className="relative z-10 max-w-4xl mx-auto text-center w-full"
      >
       
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-5 drop-shadow-sm">
          {title}
        </h1>
        {subtitle && (
          <p className="text-gray-100 text-base md:text-lg max-w-2xl mx-auto leading-relaxed mb-8">
            {subtitle}
          </p>
        )}
        {(primaryCta || secondaryCta) && (
          <div className="flex flex-wrap justify-center gap-3">
            {primaryCta &&
              (primaryCta.to.startsWith("#") ? (
                <a
                  href={primaryCta.to}
                  className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-[#F86624] hover:bg-[#e55a1a] text-white font-semibold shadow-lg transition-all"
                >
                  {primaryCta.label}
                </a>
              ) : (
                <Link
                  to={primaryCta.to}
                  className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-[#F86624] hover:bg-[#e55a1a] text-white font-semibold shadow-lg transition-all"
                >
                  {primaryCta.label}
                </Link>
              ))}
            {secondaryCta && (
              <Link
                to={secondaryCta.to}
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-white/15 hover:bg-white/25 text-white font-semibold border border-white/25 backdrop-blur-sm transition-all"
              >
                {secondaryCta.label}
              </Link>
            )}
          </div>
        )}
      </motion.div>
    </section>
  );
};

export default TrainingHero;
export { TRAINING_BANNER };
